import { ANNOTATION_HIGHLIGHT_CLASS } from '../constants'

export class HighlightService {
  constructor(private readonly root: Document | Element) {}

  private getOwnerDocument(): Document {
    if (this.root instanceof Document) {
      return this.root
    }
    return this.root.ownerDocument ?? document
  }

  wrapRange(range: Range, commentId: string, annotationIndex: number): boolean {
    try {
      const ownerDoc = this.getOwnerDocument()
      const span = ownerDoc.createElement('mark')
      span.className = ANNOTATION_HIGHLIGHT_CLASS
      span.dataset.commentId = commentId
      span.dataset.annotationIndex = String(annotationIndex)

      try {
        range.surroundContents(span)
        return true
      } catch {
        return this.wrapComplex(range, commentId, annotationIndex)
      }
    } catch {
      return false
    }
  }

  wrapComplex(
    range: Range,
    commentId: string,
    annotationIndex: number
  ): boolean {
    try {
      const ownerDoc = this.getOwnerDocument()
      const span = ownerDoc.createElement('mark')
      span.className = ANNOTATION_HIGHLIGHT_CLASS
      span.dataset.commentId = commentId
      span.dataset.annotationIndex = String(annotationIndex)

      const fragment = range.extractContents()
      span.appendChild(fragment)
      range.insertNode(span)
      return true
    } catch {
      return false
    }
  }

  removeHighlight(commentId: string, annotationIndex?: number): boolean {
    let selector = `[data-comment-id="${commentId}"]`

    if (annotationIndex !== undefined) {
      selector += `[data-annotation-index="${annotationIndex}"]`
    }

    const highlights = this.root.querySelectorAll(selector)

    if (highlights.length === 0) {
      return false
    }

    highlights.forEach((highlight) => {
      const parent = highlight.parentNode
      if (parent) {
        while (highlight.firstChild) {
          parent.insertBefore(highlight.firstChild, highlight)
        }
        highlight.remove()
        parent.normalize()
      }
    })

    return true
  }

  removeAll(): void {
    const highlights = this.root.querySelectorAll(
      `.${ANNOTATION_HIGHLIGHT_CLASS}`
    )

    highlights.forEach((highlight) => {
      const parent = highlight.parentNode
      if (parent) {
        while (highlight.firstChild) {
          parent.insertBefore(highlight.firstChild, highlight)
        }
        highlight.remove()
        parent.normalize()
      }
    })
  }
}
